import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3bb71ba0"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "pm-carousel__score" }
const _hoisted_3 = { class: "pm-carousel__details" }
const _hoisted_4 = { class: "pm-carousel__details__heading" }
const _hoisted_5 = { class: "pm-carousel__details__heading__name" }
const _hoisted_6 = { class: "pm-carousel__details__heading__time" }
const _hoisted_7 = {
  key: 1,
  class: "pm-carousel__details__response pm-carousel__details__response--no-comment"
}

import { computed } from 'vue'
import Carousel from 'primevue/carousel'
import TextClamp from '@/components/TextClamp.vue'
import { ActionResponse } from '@/entities/frontlineManagerDash'
import { shortenedPastRelativeDate } from '@/utils/time'
import { useRouter } from 'vue-router'

interface Props {
    responses: ActionResponse[]
    showCarouselIndicators: boolean
    isMobile: boolean
}

export default /*#__PURE__*/_defineComponent({
  __name: 'PraiseModalResponseCarousel',
  props: {
    responses: {},
    showCarouselIndicators: { type: Boolean, default: true },
    isMobile: { type: Boolean, default: false }
  },
  emits: ['praiseChange'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const router = useRouter()

const emit = __emit
const hasMultipleResponses = computed(() => (props.responses?.length ?? 0) > 1)
const praiseChanged = (number) => {
    emit('praiseChange', props.responses[number])
}
const viewFullResponse = (id) => {
    if (!id) return

    if (!props.isMobile) {
        window.open(`/chat/view/${id}`, '_blank')
    }
}

const getFullComment = (response: ActionResponse) => {
    if (!response?.additionalComment) {
        return response.response
    }
    if (!response.response) {
        return response.additionalComment
    }
    return `${response.response}<br />${response.additionalComment}`
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['pm-carousel', { disabled: !hasMultipleResponses.value }])
  }, [
    _createVNode(_unref(Carousel), {
      value: _ctx.responses,
      "num-visible": 1,
      circular: "",
      "show-indicators": hasMultipleResponses.value,
      "show-navigators": _ctx.showCarouselIndicators && hasMultipleResponses.value,
      "onUpdate:page": praiseChanged
    }, {
      item: _withCtx((slotProps) => [
        _createElementVNode("div", {
          class: "pm-carousel__content-container",
          role: "button",
          onClick: ($event: any) => (viewFullResponse(slotProps.data.id))
        }, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(slotProps.data.score), 1),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(slotProps.data.author), 1),
              _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(shortenedPastRelativeDate)(
                                        slotProps.data.created
                                    )), 1)
            ]),
            (getFullComment(slotProps.data))
              ? (_openBlock(), _createBlock(TextClamp, {
                  key: 0,
                  "is-html": true,
                  class: "pm-carousel__details__response",
                  text: getFullComment(slotProps.data),
                  "max-lines": 5
                }, null, 8, ["text"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_7, " No comment "))
          ])
        ], 8, _hoisted_1)
      ]),
      _: 1
    }, 8, ["value", "show-indicators", "show-navigators"])
  ], 2))
}
}

})